import React from 'react'

const Loader = () => {
  return (
    <div>
        <img style={{
            width:"30%",
            position:"absolute",
            top:"50%",
            left:"50%",
            transform: "translate(-50%,-50%)"
            
        }} src={require("../assets/9582-liquid-4-dot-loader.gif")} alt="loading..." />
    </div>
  )
}

export default Loader